import { classNames } from "@/react/helpers/twMergeWithCN";
import type { ChatCardProps } from "../../types/ChatCard";
import type { ConversationStatus } from "../../types/ConversationStatus";
import type { HelpWidgetMessage } from "../../types/help_widget_message";
import { autolink } from "../../utils/autolinkUtils";
import { extractButtons, extractCards } from "../../utils/messageUtils";
import { ChatDivider } from "./ChatDivider";
import { ChatMessage } from "./ChatMessage";

interface MessagesProps {
  messages: HelpWidgetMessage[];
  onActionButtonClick: (message: HelpWidgetMessage, event: string) => void;
  status: ConversationStatus | null;
}

export const Messages = ({
  messages,
  status,
  onActionButtonClick,
}: MessagesProps) => (
  <div className="mt-4 flex flex-1 flex-col justify-end">
    {messages?.map((message: HelpWidgetMessage, index: number) => {
      const previousMessage = index > 0 ? messages[index - 1] : null;
      const shouldShowAvatar =
        !previousMessage || previousMessage.author_type !== message.author_type;
      return (
        <div
          key={message.id}
          className={classNames({
            "mt-5": shouldShowAvatar,
            "mt-2": !shouldShowAvatar,
          })}
        >
          {message.author_type === "system" ? (
            <ChatDivider message={message} />
          ) : (
            <ChatMessage
              key={message.id}
              authorName={message.author_name}
              content={autolink(message.content)}
              channel={message.channel}
              createdAt={message.created_at.toLocaleString()}
              showFadingTextEffect={message.show_fading_text_effect}
              type={
                message.author_type === "agent"
                  ? "business"
                  : message.author_type
              }
              buttons={extractButtons(
                message,
                status === "closed",
                onActionButtonClick,
              )}
              cards={extractCards(message) as ChatCardProps[]}
              selectedButton={message.selected_button}
              shouldShowAvatar={shouldShowAvatar}
              showDisclaimer={false}
              attachments={message.attachments}
            />
          )}
        </div>
      );
    })}
  </div>
);
